import { useLocalStorage } from '@vueuse/core'

const ACCESS_TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'
const EXPIRES_AT_KEY = 'access_expires_at'

export const AUTH_STORAGE_KEYS: string[] = [ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, EXPIRES_AT_KEY]

export const lsAccessToken = useLocalStorage<string>(ACCESS_TOKEN_KEY, '')
export const lsRefreshToken = useLocalStorage<string>(REFRESH_TOKEN_KEY, '')
export const lsExpiresAt = useLocalStorage<number>(EXPIRES_AT_KEY, 0)
